import { createFileRoute } from '@tanstack/react-router';
import { DocumentTemplateForm } from '@/components/document-template-form';
import { JournalEntryForm } from '@/components/journal-entry-form';
import { EmptyState } from '@/components/page-header';
import { useT } from '@/lib/i18n';
import { useOrgId } from '@/lib/org';
import { useRecurringTemplate } from '@/lib/recurring';
import { isDocumentTemplateKind } from '@/lib/recurring-documents';

export const Route = createFileRoute('/accounting/recurring/$templateId')({
  component: EditTemplate,
});

/** Screen A7: edit a recurring template in the transaction form with its "Recurring" strip. */
function EditTemplate() {
  const orgId = useOrgId();
  const tr = useT();
  const { templateId } = Route.useParams();
  const t = useRecurringTemplate(templateId);
  if (!orgId) return <EmptyState title={tr('shell.selectClient')} />;
  if (t.isPending) return <p className="text-sm text-muted-foreground">{tr('common.loading')}</p>;
  if (t.isError)
    return (
      <EmptyState
        title={tr('accountingPages.recurringTemplate.couldNotOpen')}
        hint={t.error.message}
      />
    );
  if (isDocumentTemplateKind(t.data.kind))
    return (
      <DocumentTemplateForm key={`${orgId}-${templateId}`} kind={t.data.kind} template={t.data} />
    );
  return (
    <JournalEntryForm
      key={`${orgId}-${templateId}`}
      variant={{ kind: 'template', template: t.data }}
    />
  );
}
